const serialize = (formElement) => {
  let data = new FormData(formElement);
  let obj = {};
  for (let [key, value] of data) {
    obj[key] = value;
  }
  return obj;
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector('[type="submit"]');
    this.variantSelect = document.querySelector(
      `#${this.dataset.variantSelectId}`
    );
    if (!this.form || !this.submitButton || !this.variantSelect) return;
    this.form.querySelector("[name=id]").disabled = false;
    this.submitButton.addEventListener(
      "click",
      this.onSubmitHandler.bind(this)
    );
    this.cartNotification = document.querySelector("cart-notification");
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.classList.contains("loading")) return;
    else this.submitButton.classList.add("loading");

    const selectedVariantOption = this.variantSelect.querySelector(
      "select option:checked"
    );
    if (selectedVariantOption && selectedVariantOption.value == "placeholder") {
      const variantSelect = this.variantSelect.querySelector("select");
      variantSelect.classList.add("errorMessage");
      setTimeout(function () {
        variantSelect.classList.remove("errorMessage");
      }, 3000);
      this.submitButton.classList.remove("loading");
      return;
    }

    this.handleErrorMessage();
    this.cartNotification.setActiveElement(document.activeElement);
    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");
    const loadingSpinner = document.querySelector(".loading-overlay__spinner");
    if (loadingSpinner) loadingSpinner.classList.remove("hidden");
    const id = parseInt(serialize(this.form).id);
    const quantity = parseInt(serialize(this.form)?.quantity || "1");
    const product_form_obj = this;
    add_items_to_cart(id, quantity, "open_slider", product_form_obj);
  }
  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".product-form__error-message-wrapper");
    this.errorMessage =
      this.errorMessage ||
      this.errorMessageWrapper.querySelector(".product-form__error-message");
    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

if (!customElements.get("product-form"))
  customElements.define("product-form", ProductForm);
